import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { favoritesAPI } from '../services/api';
import './PromptCard.css';

function PromptCard({ prompt, currentUsername, showToast }) {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    if (currentUsername && prompt.id) {
      checkFavorite();
    }
  }, [currentUsername, prompt.id]);

  const checkFavorite = async () => {
    try {
      const response = await favoritesAPI.getAll(currentUsername);
      const favorites = Array.isArray(response.data) ? response.data : [];
      setIsFavorite(favorites.some(f => f.id === prompt.id));
    } catch (err) {
      // Ignore errors
    }
  };

  const toggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!currentUsername) return;

    try {
      if (isFavorite) {
        await favoritesAPI.remove(prompt.id, currentUsername);
        setIsFavorite(false);
      } else {
        await favoritesAPI.add({ prompt_id: prompt.id, username: currentUsername });
        setIsFavorite(true);
      }
    } catch (err) {
      console.error('Failed to toggle favorite:', err);
    }
  };

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const text = prompt?.prompt_text || prompt?.promptText || '';
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      if (showToast) showToast('Prompt copied to clipboard!', 'success');
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        if (showToast) showToast('Prompt copied to clipboard!', 'success');
      } catch (e2) {
        if (showToast) {
          showToast('Failed to copy. Please select and copy manually.', 'error');
        }
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="prompt-card">
      <Link to={`/prompts/${prompt.id}`} className="prompt-link">
        <h3>{prompt.title}</h3>
        <p className="prompt-preview">
          {prompt.prompt_text || prompt.promptText || ''}
        </p>
        <div className="prompt-meta">
          <div className="category-tags">
            {(prompt.category || '').split(',').map((tag, idx) => {
              const trimmedTag = tag.trim();
              return trimmedTag ? (
                <span key={idx} className="tag-pill-small">{trimmedTag}</span>
              ) : null;
            })}
          </div>
          <span className="username">by {prompt.username}</span>
        </div>
        <div className="prompt-stats">
          <span>👍 {prompt.likes || 0}</span>
          <span>👎 {prompt.dislikes || 0}</span>
        </div>
      </Link>
      {currentUsername && (
        <button
          onClick={toggleFavorite}
          className={`favorite-btn ${isFavorite ? 'active' : ''}`}
        >
          {isFavorite ? 'Saved' : 'Save'}
        </button>
      )}
      <button
        onClick={handleCopy}
        className="copy-btn"
        title="Copy prompt text"
      >
        Copy
      </button>
    </div>
  );
}

export default PromptCard;
